<template>
  <div class="fdca-footer">
    <div class="fdca-footer-box">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <p>
              Family Day Care Australia ABN 93 094 436 021 AFSL 329 616 receives
              commission and fees for arranging insurance products. For full
              details see our Financial Services Guide (FSG). Because we don’t
              know your financial needs, we can’t advise if these insurances
              will suit you and we do not take into account your personal
              circumstances. The information we provide is general in nature
              only. You should consider your needs and read the Policy Wording
              before making a decision to buy this insurance. Please call us on
              1800 658 699 for a copy of the FSG and Policy Wording.
              <!-- <router-link to="/service/premium">Bkck ot miumpre</router-link>
              Donec facilisis tortor ut augue lacinia, at viverra est semper.
              Sed sapien metus, scelerisque nec pharetra id, tempor a tortor.
              Pellentesque non dignissim neque. Ut porta viverra est, ut
              dignissim elit elementum ut. Nunc vel rhoncus nibh, ut tincidunt
              turpis. Integer ac enim pellentesque, adipiscing metus id,
              pharetra odio
              <router-link to="/educator/premium">bkck ot miumpr</router-link>. -->
            </p>
          </v-flex>
          <!-- <v-flex
            xs12
            sm12
            md3
            lg4
            x4
            text-xs-center
            text-sm-center
            text-md-right
            text-lg-right
            text-xl-right
          >
            <v-btn class="btn-feedback" round light flat>
              Feedback&nbsp;&nbsp;<IconBase><IconFeedback /></IconBase>
            </v-btn>
          </v-flex> -->
        </v-layout>
      </v-container>
    </div>
    <v-layout class="footer-copywrite" row wrap>
      <v-flex xs12 sm12 md12 lg12 xl12>
        &copy; Family Day Care Australia
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import IconFeedback from '@/components/icons/feedback.vue'
import IconBase from '@/components/IconBase.vue'

export default {
  name: 'Footer',
  components: {
    IconBase,
    IconFeedback
  }
}
</script>

<style lang="scss" scoped>
a {
  color: #0a2435;
  text-decoration: none;
}
.fdca-footer {
  position: relative;
}
</style>
